import React from "react";
import { Create, SimpleForm, TextInput, required } from "react-admin";
import Grid from "@material-ui/core/Grid";
import { GMapInput } from "../GMapInput";

const PlaceCreate = (props) => {
  return (
    <Create title="Create a Product" {...props}>
      <SimpleForm style={{ width: "100%" }}>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <TextInput
                source="name"
                isRequired
                validate={required()}
                fullWidth
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <TextInput
                source="country"
                isRequired
                validate={required()}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source="city"
                isRequired
                validate={required()}
                fullWidth
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <TextInput
                source="street"
                isRequired
                validate={required()}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source="fullAddress"
                isRequired
                validate={required()}
                fullWidth
              />
            </Grid>
          </Grid>
        </div>
        <GMapInput
          source="coordinates"
          searchable
          googleKey="AIzaSyAVHEIGJSzKAtwxbNIkkegjUK5Z4iEkLzI"
          defaultCenter={{ lat: 31.9638, lng: 35.9084 }}
          defaultZoom={15}
        />
      </SimpleForm>
    </Create>
  );
};

export default PlaceCreate;
